import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import SEO from "../../SEO";

const BASE_URL = "https://ecom.cyberathon.com";

const ViewOrder = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [cancelLoading, setCancelLoading] = useState(false);
  const [seoData, setSeoData] = useState({});
  const user_id = sessionStorage.getItem("userId");
  const navigate = useNavigate();

  const handleCancelClick = (order_id) => {
    setSelectedOrderId(order_id);
    setShowCancelModal(true);
  };

  const confirmCancelOrder = async () => {
    setCancelLoading(true);

    try {
      // ONLY Send Notification to Admin (NO order_cancle API)
      const currentOrder = orders.find(
        (order) => order.order_id === selectedOrderId
      );

      if (currentOrder && currentOrder.items && currentOrder.items.length > 0) {
        // Get first product details
        const firstProduct = currentOrder.items[0];

        const notificationRes = await axios.post(
          `${BASE_URL}/index.php/Api/add_notification`,
          {
            user_id: user_id,
            order_id: selectedOrderId,
            prod_id: firstProduct.prod_id || firstProduct.product_id,
            message: "Request for order cancellation"
          }
        );

        if (notificationRes.data.status === "true") {
          alert("Cancellation request sent to admin. Your order will be cancelled shortly.");
        // alert("Your order has been cancelled successfully!");
          setShowCancelModal(false);
          // Optional: Refresh orders to see if status changed
          fetchOrders();
        } else {
          alert("Failed to send cancellation request");
        }
      } else {
        alert("Order details not found");
      }
    } catch (err) {
      console.error("Notification Error:", err);
      alert("Failed to send cancellation request");
    } finally {
      setCancelLoading(false);
    }
  };

  useEffect(() => {
    if (user_id) {
      fetchOrders();
    } else {
      setLoading(false);
    }
  }, []);

   useEffect(() => {
  const fetchSeo = async () => {
    try {
      const response = await axios.post(
        `${BASE_URL}/index.php/Api/get_seo_by_page`,
        {
          page_name: 'order'
        }
      );

      if (response.data.status === 'true') {
        const data = response.data.data;
        setSeoData({
          title: data.meta_title,
          description: data.meta_description,
          keywords: data.meta_keywords,
          canonical: data.canonical_url,
        });
      }
    } catch (error) {
      console.error('SEO fetch error:', error);
    }
  };

  fetchSeo();
}, []);

  const renderOrderImage = (item) => {
  // VIDEO - direct uploaded
  if ( item.product_type === "coursesection") {
    return (
      <div style={{ position: "relative", width: 100, height: 100 }}>
        <video
          src={`${BASE_URL}/${item.video_file}#t=0.5`}
          style={{ width: 100, height: 100, objectFit: "cover", borderRadius: 8 }}
          preload="metadata"
          muted
          playsInline
        />
        <div style={{
          position: "absolute", top: "50%", left: "50%",
          transform: "translate(-50%,-50%)",
          background: "rgba(0,0,0,0.6)", borderRadius: "50%",
          padding: "6px 10px", color: "white", fontSize: 18
        }}>▶</div>
      </div>
    );
  }

  // EBOOK
  // if (item.product_type === "ebook") {
  //   return (
  //     <iframe
  //       src={`${BASE_URL}/${item.pdf_file}#page=1&toolbar=0&navpanes=0`}
  //       style={{ width: 100, height: 100, border: "none", borderRadius: 8 }}
  //       title="ebook-preview"
  //     />
  //   );
  // }
  
if (item.product_type === "ebook") {
  return (
    <div style={{
      width: 100, height: 100,
      background: "#fff3f3",
      border: "1px solid #ffcccc",
      borderRadius: 8,
      display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center", gap: 4
    }}>
      <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#e53e3e" strokeWidth="1.5">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
        <polyline points="14 2 14 8 20 8"/>
        <line x1="16" y1="13" x2="8" y2="13"/>
        <line x1="16" y1="17" x2="8" y2="17"/>
        <polyline points="10 9 9 9 8 9"/>
      </svg>
      <span style={{ fontSize: 10, color: "#e53e3e", fontWeight: 700 }}>PDF</span>
    </div>
  );
}

  // DEFAULT - normal product image
  return (
    <img
      src={
        Array.isArray(item.product_image) && item.product_image.length > 0
          ? `${BASE_URL}/${item.product_image[0]}`
          : "https://via.placeholder.com/100"
      }
      alt={item.product_name}
      style={{
        width: "100%", maxWidth: "100px", height: "100px",
        objectFit: "contain", border: "1px solid #ddd",
        borderRadius: "8px", padding: "5px",
      }}
    />
  );
};

  const fetchOrders = async () => {
    try {
      const res = await axios.post(
        `${BASE_URL}/index.php/Api/list_new_order`,
        { user_id }
      );

      if (res.data.status === true) {
        setOrders(res.data.orders);
      }
    } catch (error) {
      console.error("Order Fetch Error:", error);
    } finally {
      setLoading(false);
    }
  };

  if (!user_id) {
    return (
      <div className="container py-5 text-center">
        <h5>Please login to view your orders</h5>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="container py-5 text-center">
        <h5>Loading orders...</h5>
      </div>
    );
  }

  if (orders.length === 0) {
    return (
      <div className="container py-5 text-center">
        <h5>No orders found</h5>
      </div>
    );
  }

  const handleProductClick = (item) =>{
    if (item.product_type === "ebook"){
      navigate(`/EbookDetail/${item.prod_id || item.product_id}`);
    }
    else if (item.product_type === "coursesection"){
      navigate(`/coursesectiondetail/${item.prod_id || item.product_id}`);
    }
    else{
      navigate(`/DetailsSection3/${item.prod_id || item.product_id}`);
    }
  };

  return (
    <>
     <SEO
  title={seoData.title || "best cupping therapy tools ,authentic cupping supplies | shopeindia"}
  description={seoData.description || "Get in touch with ShopIndia for support, queries, or feedback."}
  keywords={seoData.keywords || "ShopIndia, contact, support, feedback"}
  canonical={seoData.canonical || "https://www.shopindia.com/contact"}
/>

      <section className="myntra-order-container py-1">
        <div className="container pt-0">
          {/* <div className="d-flex justify-content-between align-items-center mb-3 ">
          <h3 className="fw-bold mb-4">My Orders</h3>
          <button
  className="bg-col border-0 rounded-1 p-md-3 fw-bold text-light mx-5 "
  onClick={() => navigate("/products")}
>
  Continue Shopping
</button>

</div> */}

<div className="d-flex flex-wrap justify-content-between align-items-center mb-3 gap-2">
  <h3 className="fw-bold mb-0 text-nowrap">My Orders</h3>

  <button
    className="bg-col border-0 rounded-1 px-3 py-2 fw-bold text-light text-nowrap"
    onClick={() => navigate("/products")}
  >
    Continue Shopping
  </button>
</div>
          {orders.map((order) => (
            <div key={order.order_id} className="card shadow-sm mb-4">
              {/* Header */}
              <div className="card-header px-4 py-3 bg-light d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="mb-1">
                    Order ID: <strong>#{order.order_id}</strong>
                  </h6>
                  {order.order_number && (
                    <small className="text-muted">
                      Order Number: {order.order_number}
                    </small>
                  )}
                  <br />
                  <small className="text-muted">
                    Placed on: {order.order_date}
                  </small>
                </div>
              </div>

              {/* Body - Products Only */}
              <div className="card-body px-3">
                {order.items && order.items.length > 0 ? (
                  order.items.map((item, idx) => (
                    <div
                      key={idx}
                      className="row align-items-center mb-0 pb-2 border-bottom"
                      onClick={()=>handleProductClick(item)}
                      style={{cursor:"pointer"}}
                    >
                      {/* Product Image */}
                      <div className="col-md-2 col-3 text-center">
                        {/* <img
                         
                          src={
    Array.isArray(item.product_image) && item.product_image.length > 0
      ? `${BASE_URL}/${item.product_image[0]}`
      : "https://via.placeholder.com/100"
  }
                          alt={item.Product_name}
                          style={{
                            width: "100%",
                            maxWidth: "100px",
                            height: "100px",
                            objectFit: "contain",
                            border: "1px solid #ddd",
                            borderRadius: "8px",
                            padding: "5px",
                          }}
                        /> */}
                       
{/* <img
  src={
    Array.isArray(item.product_image) && item.product_image.length > 0
      ? `${BASE_URL}/${item.product_image[0]}`
      : "https://via.placeholder.com/100"
  }
  alt={item.Product_name}
 style={{
                            width: "100%",
                            maxWidth: "100px",
                            height: "100px",
                            objectFit: "contain",
                            border: "1px solid #ddd",
                            borderRadius: "8px",
                            padding: "5px",
                          }}
/> */}

{renderOrderImage(item)}
                      </div>

                      {/* Product Details */}
                      <div className="col-md-7 col-5">
                        <h6 className="mb-2 fw-bold fontmobile">{item.product_name}</h6>
                        <p className="mb-1 text-muted fontmobile">
                          Quantity: <strong>{item.qty}</strong>
                        </p>
                        <p className="mb-0 text-muted fontmobile">
                          Price: <strong>₹{item.price}</strong>
                        </p>
                      </div>

                      {/* Product Total */}
                      <div className="col-md-3 col-4 text-end">
                        <div className="d-flex align-items-center justify-content-end fontee">
                          <span>
                            {/* discount add karne ke phele wala code Nikita */}
                            {/* <p className="mb-0 fw-bold text-success fs-6">
                              <small className="text-muted ">Item Total : </small>
                              ₹{item.subtotal.toFixed(2)}
                            </p> */}

                            {/* 02-07-2026 client ne discount add karne ko bola wala code */}
                            <p className="mb-0 fw-bold text-success fs-6">
                              <small className="text-muted ">Item Total : </small>
                              ₹{Number(order.total || 0).toFixed(2)}
                            </p>
                            
                          </span>
                        </div>
                        <div className="d-flex align-items-center justify-content-end">
                          <span>
                            <p className="mb-1 fw-bold text-muted fs-6">
                              <small className="text-muted fontee">Order Status:</small>{" "}
                              <strong className="fontii">{order.order_status}</strong>
                            </p>
                          </span>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="text-center text-muted">No products found</p>
                )}
              </div>

              <div className="order-footer px-md-4 px-sm-2 py-2 d-flex justify-content-around border-top">
                <Link className="order-condition d-flex align-items-center gap-2">
                  <i className="fa-solid fa-x text-danger"></i>
                  <button
                  type="button"
                    className="btn btn-outline-danger btn-sm"
                    onClick={(e) => {
                       e.preventDefault();
                      e.stopPropagation();
                      handleCancelClick(order.order_id);
                    }}
                    disabled={order.order_status === "Cancelled"}
                  >
                    {order.order_status === "Cancelled" ? "Cancelled" : "Cancel"}
                  </button>
                </Link>

                {/* <Link to="/ordercancelled" className="order-condition d-flex align-items-center gap-2">
                  <i className="fa-solid fa-right-left text-primary"></i>
                  <button className="btn btn-outline-primary btn-sm">Return</button>
                </Link> */}

                {/* <Link to="/orderdetails" className="order-condition d-flex align-items-center gap-2">
                  <i className="fa-solid fa-location-dot text-warning"></i>
                  <button className="btn btn-outline-warning btn-sm">Track Order</button>
                </Link> */}
                {/* Track Order button - Line 148 ke around */}
<Link 
  to={`/track-order/${order.order_id}`} 
  onClick={(e) => e.stopPropagation()}
  className="order-condition d-flex align-items-center gap-2"
>
  <i className="fa-solid fa-location-dot text-warning"></i>
  <button className="btn btn-outline-warning btn-sm">Track Order</button>
</Link>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ✅ CANCEL REQUEST MODAL */}
      {showCancelModal && (
        <div className="modal-backdrop-custom">
          <div className="modal-box">
            <h5 className="mb-3">Request Order Cancellation</h5>
            <p>Your cancellation request will be sent to admin. </p>
            {/* <p>
              Your cancellation request will be sent to admin. 
              The order will be cancelled after admin approval.
            </p> */}
{/* <h5 className="mb-3">Cancel Order</h5> */}
            {/* <p>Are you sure you want to cancel this order?</p> */}
            <div className="d-flex justify-content-end gap-2 mt-4">
              <button
                className="btn btn-secondary btn-sm"
                onClick={() => setShowCancelModal(false)}
              >
                No
              </button>

              <button
                className="btn btn-danger btn-sm"
                onClick={confirmCancelOrder}
                disabled={cancelLoading}
              >
                {/* {cancelLoading ? "Sending Request..." : "Yes, Send Request"} */}
                 {cancelLoading ? "Cancelling..." : "Yes, Cancel"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ViewOrder;